<script>
import baseEdit from "@/views/components/base/baseEdit.vue";

export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "demand",
      key: "id",
      kv: "",
      url: {},
      isInitShow: true,
      items: [
        { label: "处理需求", type: "header" },
        {
          label: "需求科室",
          name: "deskName",
          value: "",
          type: "render",
          width: "400px",
          disabled: true,
          render: (e, row, text) => {
            console.log(e, row, text);
            return <span>{text.value}</span>;
          },
        },
        {
          label: "发起人",
          name: "proposerName",
          value: "",
          width: "400px",
          disabled: true,
          type: "render",
          render: (e, row, text) => {
            console.log(e, row, text);
            return <span>{text.value}</span>;
          },
          // rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "需求内容",
          name: "content",
          value: "",
          type: "render",
          disabled: true,
          width: "400px",
          render: (e, row, text) => {
            console.log(e, row, text);
            return <span>{text.value}</span>;
          },
        },
        {
          label: "需求原因",
          name: "reason",
          value: "",
          type: "render",
          disabled: true,
          width: "400px",
          render: (e, row, text) => {
            console.log(e, row, text);
            return <span>{text.value}</span>;
          },
        },
        {
          label: "紧急程度",
          name: "urgency",
          type: "render",
          width: "400px",
          disabled: true,
          value: "",
          render: (e, row, text) => {
            console.log(e, row, text);
            if (text.value == 1) {
              return <span>一般</span>;
            } else if (text.value == 2) {
              return <span>较重</span>;
            } else if (text.value == 3) {
              return <span>重要</span>;
            } else if (text.value == 4) {
              return <span>特别重要</span>;
            }
          },
        },
        // { label: "发起时间", name: "applyTime", value: "", type: "datetime" },
        {
          label: "相关文件",
          name: "demandFileUrl",
          value: "",
          type: "render",
          disabled: true,
          render: (p, row, data) => {
            console.log(data.value);
            const urlList = data.value ? data.value.split(",") : [];
            if (urlList.length > 0) {
              return h(
                "div",
                urlList.map((url) =>
                  h(
                    "a",
                    {
                      attrs: {
                        href: url,
                        target: "_blank",
                      },
                      style: { display: "block" },
                    },
                    url.substring(url.lastIndexOf("/") + 1)
                  )
                )
              );
            }
          },
        },
      ],
      forms: {},
    };
  },
  async created() {
    // this.forms.accepterId = $utils.data.get("auth", "uid");
    // this.forms.accepterName = $utils.data.get("auth", "userName");
    // this.forms.initialAssigneeId = $utils.data.get("auth", "uid");
    // await this.projectData();
    let query = this.$route.query;
    if (query && query.action === "edit") {
      this.kv = query.kv;
      // this.initData();
    }
  },
  mounted() {
    // this.onisParent(1);
  },
  methods: {
    onChangeFun(e) {
      console.log(e, 111111);
      switch (e) {
        case 1:
          this.items[this.getItemIndex("newAssigneeId")].type = "kong";
          break;
        case 3:
          this.items[this.getItemIndex("newAssigneeId")].type = "kong";
          break;
        case 4:
          this.items[this.getItemIndex("newAssigneeId")].type = "kong";
          break;

        default:
          this.items[this.getItemIndex("newAssigneeId")].type = "select";
          break;
      }
    },

    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load(`/admin/system/desk/selectList`, q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.deskName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "deskId") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    initData() {
      if (this.isInitShow) {
        // 加载详情数据
        let id = this.kv;
        $utils.api.load(`/admin/system/sysDemand/${id}`, {}).then((res) => {
          if (res && res.data) {
            this.isInitShow = false;
            console.log(res.data);
            this.forms = res.data;
            res.data.demandHistoryList.forEach((item) => {
              let arr = [
                {
                  label: "指派负责人",
                  name: "newAssigneeId1",
                  type: "render",
                  width: "400px",
                  value: "",
                  render: (q, row, text) => {
                    return <span>{item.newAssigneeName}</span>;
                  },
                },
                {
                  label: "状态",
                  name: "newStatus1",
                  type: "render",
                  width: "400px",
                  disabled: true,
                  value: "",
                  render: (q, row, text) => {
                    if (item.newStatus == 0) {
                      return <span>待受理</span>;
                    } else if (item.newStatus == 1) {
                      return <span>不予受理</span>;
                    } else if (item.newStatus == 2) {
                      return <span>处理中</span>;
                    } else if (item.newStatus == 3) {
                      return <span>处理完成</span>;
                    } else if (item.newStatus == 4) {
                      return <span>待立项</span>;
                    }
                  },
                },
              ];
              this.items = [...this.items, ...arr];
            });
            this.items.push(
              {
                label: "处理意见（状态）",
                name: "newStatus",
                type: "select",
                width: "400px",
                value: "",
                onChange: this.onChangeFun,
                dropList: [
                  {
                    value: 1,
                    name: "不予受理",
                  },
                  {
                    value: 2,
                    name: "处理中",
                  },
                  {
                    value: 3,
                    name: "处理完成",
                  },
                  {
                    value: 4,
                    name: "待立项",
                  },
                ],
                rules: [
                  {
                    required: true,
                    trigger: "blur",
                    message: "请选择处理意见（状态）",
                    type: "number",
                  },
                ],
              },
              {
                label: "转派给下一个负责人",
                name: "newAssigneeId",
                type: "select",
                width: "400px",
                value: "",
                dropList: [],
                rules: [
                  {
                    required: true,
                    trigger: "blur",
                    message: "请选择负责人",
                    type: "number",
                  },
                ],
              }
            );

            this.loadAdminUserData();
            this.loadLevelData();
          }
        });
      }
    },
    //1代表存在父级
    //0代表不存在父级
    onisParent(val) {
      if (val == 1) {
        this.items[this.getItemIndex("resultFileUrl")].type = "kong";
        this.items[this.getItemIndex("finishContent")].type = "kong";
      }
      if (val == 2) {
        this.items[this.getItemIndex("resultFileUrl")].type = "documents";
        this.items[this.getItemIndex("finishContent")].type = "textarea";
      }
    },
    async handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = {};
      q.newStatus = this.forms.newStatus;
      q.demandId = this.kv;
      q.newAssigneeId = this.forms.newAssigneeId;
      console.log(q);
      await this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/sysDemand/reassign`, q, "PUT")
            .then((res) => {
              this.sloading = false;
              if (res.code == 200) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
              // if (this.action == "edit") {
              //   setTimeout(() => {
              //     this.$Modal.remove();
              //     $utils.url.go(-1);
              //   }, 1000);
              // } else {
              //   setTimeout(() => {
              //     this.$Modal.remove();
              //     $utils.url.go(-1);
              //   }, 1000);
              // }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },

    //选择处理人下拉框
    async loadAdminUserData() {
      // 通过pk查询字典数据
      let q = {};
      let res = await $utils.api.load("/admin/system/user/listPrincipal", q);
      if (res && res.rows) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.nickName;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          // if (element && element.name == "initialAssigneeId") {
          //   this.items[index]["dropList"] = dropList;
          // }
          // if (element && element.name == "proposerId") {
          //   this.items[index]["dropList"] = dropList;
          // }
          if (element && element.name == "newAssigneeId") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
  },
};
</script>
